import { fork } from 'redux-saga/effects';

import personalizationSagas from './personalization/sagas';

const scheduleReminderSagas = [fork(personalizationSagas)];

export default scheduleReminderSagas;
